import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkActions = ({ 
  selectedContacts, 
  onClearSelection, 
  onBulkCall, 
  onBulkAssignCampaign,
  onBulkExport,
  onBulkDelete 
}) => {
  const campaignOptions = [
    { value: 'new-product', label: 'Yeni Ürün Tanıtımı' },
    { value: 'customer-satisfaction', label: 'Müşteri Memnuniyeti' },
    { value: 'sales-follow', label: 'Satış Takibi' },
    { value: 'win-back', label: 'Geri Kazanım' }
  ];

  if (selectedContacts?.length === 0) {
    return null;
  }

  return (
    <div className="bg-primary/5 border-b border-primary/20 p-4">
      <div className="flex items-center justify-between">
        <div className="flex items-center space-x-4">
          <div className="flex items-center space-x-2">
            <Icon name="CheckSquare" size={18} className="text-primary" />
            <span className="text-sm font-medium text-slate-900">
              {selectedContacts?.length} kişi seçildi
            </span>
          </div>
          
          <Button
            variant="ghost"
            size="sm"
            onClick={onClearSelection}
            iconName="X"
          >
            Seçimi Temizle
          </Button>
        </div>

        <div className="flex items-center space-x-2">
          {/* Campaign Assignment */}
          <div className="flex items-center space-x-2">
            <span className="text-sm text-slate-600">Kampanyaya Ata:</span>
            <Select
              placeholder="Kampanya seç"
              options={campaignOptions}
              value=""
              onChange={(value) => onBulkAssignCampaign(value)}
              className="w-48"
            />
          </div>

          {/* Bulk Actions */}
          <div className="flex items-center space-x-2 border-l border-slate-200 pl-4">
            <Button
              variant="outline"
              size="sm"
              onClick={onBulkCall}
              iconName="Phone"
              disabled={selectedContacts?.length > 10}
            >
              Toplu Ara ({selectedContacts?.length > 10 ? 'Max 10' : selectedContacts?.length})
            </Button>
            
            <Button
              variant="outline"
              size="sm"
              onClick={onBulkExport}
              iconName="Download"
            >
              Dışa Aktar
            </Button>
            
            <Button
              variant="destructive"
              size="sm"
              onClick={onBulkDelete}
              iconName="Trash2"
            >
              Sil
            </Button>
          </div>
        </div>
      </div>
      {selectedContacts?.length > 10 && (
        <div className="mt-2 text-xs text-amber-600 flex items-center">
          <Icon name="AlertTriangle" size={14} className="mr-1" />
          Toplu arama için maksimum 10 kişi seçebilirsiniz.
        </div>
      )}
    </div>
  );
};

export default BulkActions;